import { TradeTradeGroupInsertInput } from 'generated/graphql';

export const mapTradeGroupsFormValuesToTradeGroupObjects = (
  tradeGroupIds: number[],
): TradeTradeGroupInsertInput[] => {
  return tradeGroupIds.map((tradeGroupId) => {
    return { tradeGroupId };
  });
};
